<fieldset ngl-radio-group label="{{ to.label }}" [required]="to.required || false">
  <ngl-radio-option *ngFor="let item of fields" [label]="item.templateOptions?.label || ''">
    <input ngl type="radio" [formControl]="$any(formControl)" [value]="item.templateOptions?.['value']" />
  </ngl-radio-option>
</fieldset>
